import React from 'react';
import { reduxForm, Field } from 'redux-form';

import FormError from './FormError';
import InputField from './InputField';
import SelectField from './SelectField';
import CheckboxField from './CheckboxField';
import { formatSaveStatus } from '../helpers/formatters';
import moment from 'moment';

let InsuranceDeviceForm = ({
  handleSubmit,
  setBrand,
  initialValues,
  saveStatus,
  brands,
  devices,
  error,
}) => {
  const changeBrand = ({ target: { value } }) => {
    setBrand(value);
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Field component={InputField} name="contract" label="Contract ID*" />
        {brands.length ? (
          <Field
            component={SelectField}
            name="brand_specs"
            empty="Choose a brand"
            label="Device Specs Brand*"
            options={brands.map(({ brand }) => [brand, `${brand}`])}
            onChange={changeBrand}
          />
        ) : (
          <p>
            <b>Loading...</b>
          </p>
        )}
        {devices.length ? (
          <Field
            component={SelectField}
            name="device_specs"
            empty="Choose a device"
            label="Device Specs*"
            options={devices.map((device) => [
              device.sku,
              `Sku: ${device.sku} Brand: ${device.brand} Name: ${device.name} Capacity: ${device.capacity}`,
            ])}
          />
        ) : (
          <p>
            <b>Loading...</b>
          </p>
        )}
        <Field
          component={SelectField}
          name="plan_type"
          label="Plan Type*"
          empty="Choose a plan type"
          options={[['WEWP', 'Wing Device Protection']]}
        />
        <Field
          component={SelectField}
          name="condition"
          label="Condition*"
          empty="Choose a condition"
          options={[
            ['new', 'New'],
            ['like_new', 'Like-New'],
            ['byod', 'BYOD'],
          ]}
        />
        <Field
          component={InputField}
          type="date"
          name="purchase_date"
          label="Purchase Date*"
          max={moment().utc().format('YYYY-MM-DD')}
        />
        <br />

        <Field
          component={CheckboxField}
          name="is_replacement"
          label="Is this a replacement?"
        />

        <br />

        <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
          Save Device
        </button>

        {error && <FormError error={error} />}

        <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
      </form>
    </div>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.contract) {
    errors.contract = 'Required';
  }
  if (!values.device_specs) {
    errors.device_specs = 'Required';
  }
  if (!values.plan_type) {
    errors.plan_type = 'Required';
  }
  if (!values.condition) {
    errors.condition = 'Required';
  }
  if (!values.purchase_date) {
    errors.purchase_date = 'Required';
  }

  return errors;
};

InsuranceDeviceForm = reduxForm({
  form: 'insuranceDevice',
  validate,
})(InsuranceDeviceForm);

export default InsuranceDeviceForm;
